import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  FINANCIAL_DOMAIN_INTRO,
  FINANCIAL_GROUPS,
  FINANCIAL_USE_CASES_SEO,
  FINANCIAL_DOMAIN_FAQS,
  FINANCIAL_ITEM_LIST_JSONLD,
  FINANCIAL_BREADCRUMB_JSONLD,
  FINANCIAL_WEBPAGE_JSONLD,
  FINANCIAL_FAQ_JSONLD,
} from "../../data/rpa/financial-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = FINANCIAL_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function FinancialRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? FINANCIAL_GROUPS
      : FINANCIAL_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={FINANCIAL_DOMAIN_INTRO}
        domainSlug="financial-domain"
        basePath="/rpa-use-cases"
        useCaseCount={FINANCIAL_USE_CASES_SEO.length}
        groupCount={FINANCIAL_GROUPS.length}
        itemListJsonLd={FINANCIAL_ITEM_LIST_JSONLD}
        faqJsonLd={FINANCIAL_FAQ_JSONLD}
        breadcrumbJsonLd={FINANCIAL_BREADCRUMB_JSONLD}
        webPageJsonLd={FINANCIAL_WEBPAGE_JSONLD}
        keywords="Financial Domain automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{FINANCIAL_DOMAIN_INTRO.title}</h1>
          {FINANCIAL_DOMAIN_INTRO.content ? <p>{FINANCIAL_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={FINANCIAL_USE_CASES_SEO}
        groups={FINANCIAL_GROUPS}
        heading="Financial Domain Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={FINANCIAL_DOMAIN_INTRO.title}
        domainFaqs={FINANCIAL_DOMAIN_FAQS}
        useCases={FINANCIAL_USE_CASES_SEO}
      />
    </div>
  );
}

